/* index.js */

"use strict";
const _ = require("lodash");
const uiCore = require("@gluenetworks/steve_ui_core");
const ButtonControl = uiCore.Control.Action.Button;

module.exports = {
    actionButtonsFormatter,
    sharedCheckboxFormatter,
    descriptionFormatter,
    nameFormatter,
    connectionTypeNameFormatter,
};

function actionButtonsFormatter() {
    return (row, cell, value, columnDef, dataContext) => {
        const isInherited = _.get(dataContext, "isInherited", false);
        const isSystemManaged = _.get(dataContext, "isSystemManaged", false);

        const deleteDisabled = isInherited || isSystemManaged;
        const deleteTooltip =
            isSystemManaged && !isInherited
                ? "This connection is system-managed and cannot be deleted"
                : undefined;

        const actions = [
            _generateButtons(isInherited ? "View" : "Edit", isInherited ? "view" : "edit", row),
            _generateButtons("Delete", "delete", row, deleteDisabled, deleteTooltip),
        ];

        columnDef.width = Math.max(columnDef.width, actions.length * 60 + 10);
        return actions.map((btn) => btn.renderer.rootElement.outerHTML).join("");
    };
}

function sharedCheckboxFormatter(row, cell, value, columnDef, dataContext) {
    const el = value ? document.createElement("base-icon-gl") : document.createElement("div");
    if (value) {
        el.dataset.icon = "common.check";
        el.setDarkTheme(true);
    }
    if (_.get(dataContext, "isInherited", false)) {
        el.classList.add("read-only-block");
    }
    return el.outerHTML;
}

function _generateButtons(label, action, row, disabled, tooltip) {
    const btn = new ButtonControl({
        label: label,
        darkTheme: true,
        disabled: disabled,
    });
    btn.setAttribute("role", "button");
    btn.setAttribute("action", action);
    btn.setAttribute("row", row);
    if (tooltip) {
        btn.renderer.getRootElement().setAttribute("title", tooltip);
    }
    return btn;
}

function descriptionFormatter(row, cell, value) {
    const description = document.createElement("div");
    description.classList.add("description-column");
    description.innerText = value || "";
    description.setAttribute("title", value);
    return description.outerHTML;
}

function nameFormatter(row, cell, value) {
    const name = document.createElement("div");
    name.classList.add("name-column");
    name.innerText = value || "";
    name.setAttribute("title", value);
    return name.outerHTML;
}

function connectionTypeNameFormatter(row, cell, value) {
    const name = document.createElement("div");
    name.classList.add("connection-type-name-column");
    name.innerText = value || "";
    name.setAttribute("title", value);
    return name.outerHTML;
}
